<template>
  <page-wrapper title="รายงาน Error ไม่ส่งไป SAP (FI)">
    <div class="page-container">
      <div class="row" style="padding-left: 35px">
        <div class="query-box">
          <div class="label col-12">วันที่ในใบเสร็จรับเงิน</div>
          <date-picker
            v-model="receiptDateRange"
            type="daterange"
          ></date-picker>
        </div>
      </div>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
      <div class="report-container">
        <div class="report">
          <div
            v-for="(fiReportError, index) in sapFiReportErrorPresenters"
            :key="index"
            :class="{ header: index === 0 }"
            class="fi-report-row"
          >
            <div class="report-cell">
              <div v-if="fiReportError.appointmentRoute">
                <router-link :to="fiReportError.appointmentRoute">{{
                  fiReportError.appointmentText
                }}</router-link>
              </div>
              <div v-else>{{ fiReportError.appointmentText }}</div>
            </div>
            <div class="report-cell">
              <div v-if="fiReportError.receiptRoute">
                <router-link :to="fiReportError.receiptRoute">{{
                  fiReportError.documentNumberText
                }}</router-link>
              </div>
              <div v-else>{{ fiReportError.documentNumberText }}</div>
            </div>
            <div class="report-cell">
              {{ fiReportError.receiptSignedAtDate }}
            </div>
            <div class="report-cell">
              {{ fiReportError.receiptType }}
            </div>
            <div class="report-cell">
              {{ fiReportError.customerName }}
            </div>
            <div class="report-cell">
              {{ fiReportError.errorMassage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import DatePicker from "@/lib/components/DatePicker"
import { DateTime } from "luxon"
import PageWrapper from "@/lib/components/PageWrapper"
import { baanRueJaiClient } from "@/dependencies"
import ScButton from "@/lib/components/ScButton"
import { receiptTypeEN } from "@/lib/mapper"
import { existValueAndEmptyString } from "@/lib/util"

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
  },
  data() {
    return {
      sapFiErrorReports: [],
      receiptDateRange: [],
      query: [],
    }
  },
  computed: {
    sapFiReportErrorPresenters() {
      const header = {
        appointmentText: "นัดหมาย",
        documentNumberText: "เลขที่ใบเสร็จรับเงิน/ใบกำกับภาษี",
        receiptSignedAtDate: "วันที่ใบเสร็จ",
        receiptType: "ประเภทใบเสร็จ/ใบกำกับภาษี",
        customerName: "ชื่อลูกค้า",
        errorMassage: "Error massage",
      }

      return [header, ...this.sapFiErrorReports]
    },
    queryParams() {
      const { receiptDateFrom, receiptDateTo } = this.$route.query

      return {
        receiptDateFrom,
        receiptDateTo,
      }
    },
  },
  watch: {
    "$route.query": function routeQueryWatcher() {
      this.setupData()
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupForm()
      this.setupData()
    },
    setupForm() {
      const { receiptDateFrom, receiptDateTo } = this.$route.query

      if (!receiptDateFrom && !receiptDateTo) {
        return
      }

      this.receiptDateRange = [
        DateTime.fromISO(receiptDateFrom),
        DateTime.fromISO(receiptDateTo),
      ]
    },
    setupData() {
      this.setupSapFiErrorReports()
    },
    async setupSapFiErrorReports() {
      const sapFiErrorReports = await this.fetchSapFiErrorReports()

      this.sapFiErrorReports = sapFiErrorReports.map((sapFiErrorReport) => {
        const appointmentRoute = sapFiErrorReport.appointment_id
          ? {
              name: "AppointmentDetailPage",
              params: { id: sapFiErrorReport.appointment_id },
            }
          : undefined

        const receiptRoute = existValueAndEmptyString(
          sapFiErrorReport.receipt_id,
        )
          ? {
              name: "ReceiptDetailPage",
              params: { id: sapFiErrorReport.receipt_id },
            }
          : undefined

        let documentNumberText = ""
        if (existValueAndEmptyString(sapFiErrorReport.document_number)) {
          documentNumberText = sapFiErrorReport.document_number
        } else if (existValueAndEmptyString(sapFiErrorReport.receipt_id)) {
          documentNumberText = "กดเพื่อดูใบเสร็จ"
        }

        return {
          appointmentRoute,
          receiptRoute,
          customerName: sapFiErrorReport.customer_name,
          errorMassage: sapFiErrorReport.error_massage,
          documentNumberText,
          receiptType:
            sapFiErrorReport.receipt_type === receiptTypeEN.TAX_INVOICE
              ? "ใบกำกับภาษี"
              : "ใบเสร็จรับเงิน/ใบลดหนี้",
          appointmentText: sapFiErrorReport.appointment_id
            ? "กดเพื่อดูนัดหมาย"
            : "",
          receiptSignedAtDate: sapFiErrorReport.signed_at,
        }
      })
    },
    async fetchSapFiErrorReports() {
      const response = await baanRueJaiClient.admin.sap.getSapFiErrorReportList(
        this.queryParams,
      )

      return response.data.result
    },
    handleClickSearch() {
      let receiptDateFrom
      let receiptDateTo
      if (this.receiptDateRange && this.receiptDateRange.length > 1) {
        receiptDateFrom = this.receiptDateRange[0].toISO()
        receiptDateTo = this.receiptDateRange[1].toISO()
      }

      const query = {
        receiptDateFrom,
        receiptDateTo,
      }
      this.$router.push({ query })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.report-container {
  padding: 20px 0;
  width: 100%;
}

.fi-report-row {
  display: grid;
  grid-template-columns:
    200px
    250px
    250px
    250px
    300px
    600px;
}

.fi-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  padding: 10px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);
}

.report {
  padding: 15px;
}

.query-box {
  padding-right: 10px;
  padding-bottom: 10px;
  padding-top: 15px;
}

.csv {
  padding-left: 14px;
}
</style>
